import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as BackupListActions from '../actions/backup-list.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadBackupList} from "../actions/backup-list.action";
import {BackupService} from "../../websites/website/backup/backup.service";

@Injectable()
export class BackupListEffect {

  loadBackupList$ = createEffect(() => this._actions$.pipe(
    ofType(BackupListActions.LOAD_BACKUP_LIST),
    mergeMap((action: LoadBackupList) => {
      const websiteId = action.payload;
      return this._backupService.getBackupsList(websiteId).pipe(
        filter((response: DbResponse) => !!response),
        map((response: DbResponse) => {
          if (response.success) {
            return new BackupListActions.LoadBackupListSuccess(
              {
                websiteId,
                entities: response.data
              }
            );
          }
        })
      );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _backupService: BackupService,
  ) {
  }

}
